<div class="flex p-1 gap-2 text-center">
    <img src="assets/images/icons/lamella.svg" width="24" height="24" alt="lamella"/>
    <h6 class="text-gray-500 font-semibold uppercase self-center">
        {{ 'TABLES.LAMELLA.TITLE' | translate }}
    </h6>
</div>

<hr class="h-0.5 border-t-0 bg-gray-500" />

<table role="table" class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
    <tr class="border-b">
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.PRODUCT_FAMILY' | translate }}</th>
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.LAMELLA' | translate }}</th>
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.SURFACE' | translate }}</th>
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.COLOR' | translate }}</th>
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.QUANTITY_NET' | translate }}</th>
        <th scope="col" class="px-6 py-3">{{ 'TABLES.LAMELLA.QUANTITY_GROSS' | translate }}</th>
    </tr>
    </thead>

    <tbody>

    @for( lamellaConsumption of calculateConsumption(lamellaCuttingPlan()); track $index){
        <tr class="border-b">
            <th scope="row" class="px-6 py-4 font-medium">{{lamellaConsumption.productCode}}</th>
            <td class="px-6 py-4">{{lamellaConsumption.productCode}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.material | translate}}</td>
            <td class="px-6 py-4">@if(lamellaConsumption.material == "Powder Coated"){RAL }{{lamellaConsumption.color.RAL}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.netto / 1000 | number:'1.0-3'}} m</td>
            <td class="px-6 py-4">{{lamellaConsumption.brutto / 1000 | number:'1.0-3'}} m</td>
        </tr>
    }

    @for( lamellaConsumption of calculateConsumption(mountingProfileCuttingPlan()); track $index){
        <tr class="border-b">
            <th scope="row" class="px-6 py-4 font-medium">{{"QUANTITY.MOUNTING_PROFILE" | translate}}</th>
            <td class="px-6 py-4">{{lamellaConsumption.productCode}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.material | translate}}</td>
            <td class="px-6 py-4">@if(lamellaConsumption.material == "Powder Coated"){RAL }{{lamellaConsumption.color.RAL}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.netto / 1000 | number:'1.0-3'}} m</td>
            <td class="px-6 py-4">{{lamellaConsumption.brutto / 1000 | number:'1.0-3'}} m</td>
        </tr>
    }

    @for( lamellaConsumption of calculateConsumption(frameProfileCuttingPlan()); track $index){
        <tr class="border-b">
            <th scope="row" class="px-6 py-4 font-medium">{{"QUANTITY.FRAME_PROFILE" | translate}}</th>
            <td class="px-6 py-4">{{lamellaConsumption.productCode}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.material | translate}}</td>
            <td class="px-6 py-4">@if(lamellaConsumption.material == "Powder Coated"){RAL }{{lamellaConsumption.color.RAL}}</td>
            <td class="px-6 py-4">{{lamellaConsumption.netto / 1000 | number:'1.0-3'}} m</td>
            <td class="px-6 py-4">{{lamellaConsumption.brutto / 1000 | number:'1.0-3'}} m</td>
        </tr>
    }






    </tbody>
</table>

<div>
    <div class="flex p-1 gap-2 text-center">
        <img src="assets/images/icons/screw.svg" width="24" height="24" />
        <h6 class="text-gray-500 font-semibold uppercase self-center">
            {{ 'TABLES.ACCESSORIES.TITLE' | translate }}
        </h6>
    </div>

    <hr class="h-0.5 border-t-0 bg-gray-500" />

    <table role="table" class="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
        <tr class="border-b">
            <th scope="col" class="px-6 py-3">{{ 'TABLES.ACCESSORIES.ITEM' | translate }}</th>
            <th scope="col" class="px-6 py-3">{{ 'TABLES.ACCESSORIES.MODEL' | translate }}</th>
            <th scope="col" class="px-6 py-3">{{ 'TABLES.ACCESSORIES.QUANTITY' | translate }}</th>
            <th scope="col" class="px-6 py-3">{{ 'TABLES.ACCESSORIES.UNIT' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr class="border-b">
            <th scope="row" class="px-6 py-4 font-medium">Fixplate 1</th>
            <td class="px-6 py-4">JMNapsufixplate1</td>
            <td class="px-6 py-4">{{accessories().fixplate1}}</td>
            <td class="px-6 py-4">Kpl</td>
        </tr>
        @if(accessories().fixplate2){
            <tr class="border-b">
                <th scope="row" class="px-6 py-4 font-medium">Fixplate 2</th>
                <td class="px-6 py-4">JMNapsufixplate2</td>
                <td class="px-6 py-4">{{accessories().fixplate2}}</td>
                <td class="px-6 py-4">Kpl</td>
            </tr>
        }
        @if(accessories().fixplate4){
            <tr class="border-b">
                <th scope="row" class="px-6 py-4 font-medium">Fixplate 4</th>
                <td class="px-6 py-4">JMNapsufixplate4</td>
                <td class="px-6 py-4">{{accessories().fixplate4}}</td>
                <td class="px-6 py-4">Kpl</td>
            </tr>
        }
        <tr class="border-b">
            <th scope="row" class="px-6 py-4 font-medium">Screws</th>
            <td class="px-6 py-4">JMRUUVI4819_25</td>
            <td class="px-6 py-4">{{calculateScrewPackages(accessories().screws)}}</td>
            <td class="px-6 py-4">Pakkaus (500kpl)</td>
        </tr>
        </tbody>
    </table>

</div>

<div class="bg-primary-200 rounded-2xl border-2 border-primary p-4 w-full">
    <h3 class="capitalize tracking-wide font-bold">
        {{ 'ALERT.TITLE' | translate }}
    </h3>
    <span class="tracking-wide font-medium">
    {{ 'ALERT.MESSAGE' | translate }}
        <a
                class="underline font-semibold text-secondary-600 hover:text-primary-950"
                [href]="'ALERT.LINK_URL' | translate"
                target="_blank">
          {{ 'ALERT.LINK_TEXT' | translate }}
        </a>
  </span>
</div>
